import { render, staticRenderFns } from "./Stsg.vue?vue&type=template&id=7d79ed7e&scoped=true"
import script from "./Stsg.vue?vue&type=script&lang=js"
export * from "./Stsg.vue?vue&type=script&lang=js"
import style0 from "./Stsg.vue?vue&type=style&index=0&id=7d79ed7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d79ed7e",
  null
  
)

export default component.exports